<elcia-dropdown [control]="control()"
                [items]="accountingAccounts()"
                [label]="'entity.accounting-account' | translate"
                [textField]="'name'">
  <ng-template #item let-item>
    <div class="flex gap-2">
      <div>
        {{ item.name }}
      </div>
      <div>
        ({{ item.account }})
      </div>
    </div>
  </ng-template>
</elcia-dropdown>
